"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_1 = __importDefault(require("@emotion/styled"));

var Info_1 = require("./Info");

var StyledLabel = styled_1.default.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  position: relative;\n  padding-left: 0;\n  margin-bottom: 0;\n"], ["\n  display: block;\n  position: relative;\n  padding-left: 0;\n  margin-bottom: 0;\n"])));
var StyledRequired = styled_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  content: '*';\n"], ["\n  content: '*';\n"])));

exports.Label = function (_a) {
  var children = _a.children,
      required = _a.required,
      info = _a.info,
      props = __rest(_a, ["children", "required", "info"]);

  return react_1.default.createElement(StyledLabel, __assign({}, props), children, required ? react_1.default.createElement(StyledRequired, null) : null, info ? react_1.default.createElement(Info_1.Info, null, info) : null);
};

var templateObject_1, templateObject_2;